import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const HouseIcon = () => (
  <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="34" height="34" rx="8" fill="#9B2335" />
    <path
      d="M17 7L6 16.5h3.5V27h5v-5.5h5V27h5V16.5H28L17 7z"
      stroke="white"
      strokeWidth="1.8"
      strokeLinejoin="round"
      strokeLinecap="round"
      fill="none"
    />
  </svg>
);

const navLinks = [
  { label: 'Leistungen',          id: 'leistungen' },
  { label: 'Kooperationspartner', id: 'kooperationspartner' },
  { label: 'Mietinteresse',       id: 'mietinteresse' },
  { label: 'Kontakt',             id: 'kontakt' },
];

export default function Navbar() {
  const [open, setOpen]       = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location              = useLocation();

  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 10);
    window.addEventListener('scroll', fn);
    return () => window.removeEventListener('scroll', fn);
  }, []);

  useEffect(() => { setOpen(false); }, [location]);

  const scrollTo = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <header className={`nav${scrolled ? ' nav--scrolled' : ''}`}>
      <div className="container nav__inner">

        <a href="#/" className="nav__logo" aria-label="Huusmacher Startseite">
          <HouseIcon />
          <span className="nav__wordmark">Huusmacher</span>
        </a>

        <nav className={`nav__links${open ? ' nav__links--open' : ''}`}>
          {navLinks.map(l => (
            <button key={l.id} className="nav__link" onClick={() => scrollTo(l.id)}>
              {l.label}
            </button>
          ))}
          <Link to="/impressum" className="nav__link">Impressum</Link>

          <div className="nav__contact-bar">
            <a href="tel:04018230400" className="nav__contact-link" title="Hamburg">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.8 19.79 19.79 0 01.04 1.18 2 2 0 012.03 0h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.09 7.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 14.92z"/></svg>
              040 18230400
            </a>
            <a
              href="https://www.google.com/maps/search/Hinter+der+Schule+2,+22145+Stapelfeld"
              target="_blank"
              rel="noopener noreferrer"
              className="nav__contact-link"
              title="Standort Hamburg"
            >
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z"/><circle cx="12" cy="9" r="2.5"/></svg>
              Stapelfeld
            </a>
          </div>

          <a href="mailto:info@huusmacher.de" className="btn btn-primary btn-sm nav__cta">
            Beratung anfragen
          </a>
        </nav>

        <button
          className="nav__hamburger"
          aria-label="Menü"
          onClick={() => setOpen(o => !o)}
        >
          <span className={`nav__ham-line${open ? ' nav__ham-line--1-open' : ''}`} />
          <span className={`nav__ham-line${open ? ' nav__ham-line--2-open' : ''}`} />
          <span className={`nav__ham-line${open ? ' nav__ham-line--3-open' : ''}`} />
        </button>

      </div>
    </header>
  );
}
